"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6874],{

/***/ 9354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ diamondVnd; },
/* harmony export */   "OR": function() { return /* binding */ diamondDate; },
/* harmony export */   "ZS": function() { return /* binding */ DiamondCatalogue; },
/* harmony export */   "_g": function() { return /* binding */ DiamondIllustration; },
/* harmony export */   "ap": function() { return /* binding */ DiamondNavigationStatus; },
/* harmony export */   "fM": function() { return /* binding */ DiamondProfileLink; },
/* harmony export */   "iO": function() { return /* binding */ diamondUsd; },
/* harmony export */   "w1": function() { return /* binding */ diamondCarat; }
/* harmony export */ });
/* unused harmony export DiamondPagination */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_ui_JsonLd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59904);
/* harmony import */ var _constants_business__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56154);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41046);
/* harmony import */ var _diamond_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55187);
/* harmony import */ var _diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29233);









var diamondUsd = function(value) {
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0
    }).format(value);
};
var diamondVnd = function(value) {
    return new Intl.NumberFormat("vi-VN", {
        maximumFractionDigits: 0
    }).format(value);
};
var diamondDate = function(value) {
    return value.slice(0, 10).split("-").reverse().join("/");
};
var diamondCarat = function(value) {
    return value.toFixed(2).replace(".", ",");
};
/** Source-backed routes can take longer on the first visit; acknowledge navigation. */ var DiamondNavigationStatus = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), pending = ref[0], setPending = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var start = function() {
            return setPending(true);
        };
        var finish = function() {
            return setPending(false);
        };
        router.events.on("routeChangeStart", start);
        router.events.on("routeChangeComplete", finish);
        router.events.on("routeChangeError", finish);
        return function() {
            router.events.off("routeChangeStart", start);
            router.events.off("routeChangeComplete", finish);
            router.events.off("routeChangeError", finish);
        };
    }, [
        router.events
    ]);
    return pending ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        role: "status",
        className: "tw-fixed tw-bottom-5 tw-left-1/2 tw-z-50 -tw-translate-x-1/2 tw-whitespace-nowrap tw-rounded-lg tw-bg-jr-green tw-px-5 tw-py-3 tw-text-[14px] tw-text-white tw-shadow-lg",
        children: "Đang mở trang tham khảo…"
    }) : null;
};
var DiamondIllustration = function(param) {
    var shape = param.shape, _large = param.large, large = _large === void 0 ? false : _large;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.2",
        className: large ? "tw-h-40 tw-w-40 md:tw-h-56 md:tw-w-56" : "tw-h-16 tw-w-16",
        "aria-hidden": "true",
        children: shape === "round" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "50",
                    cy: "50",
                    r: "38"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m50 12 27 11 11 27-11 27-27 11-27-11-11-27 11-27 27-11Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m50 12 18 20 20 18-20 18-18 20-18-20-20-18 20-18 18-20Zm-18 20h36v36H32V32Zm0 0L23 23m45 9 9-9M68 68l9 9m-45-9-9 9M12 50h76M50 12v76"
                })
            ]
        }) : shape === "oval" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                    cx: "50",
                    cy: "50",
                    rx: "30",
                    ry: "42"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m50 8 20 42-20 42-20-42L50 8Zm-30 42h60M50 8v84M27 22l46 56m0-56L27 78"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m32 8-15 15v54l15 15h36l15-15V23L68 8H32Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m37 20-9 9v42l9 9h26l9-9V29l-9-9H37Zm5 12-3 5v26l3 5h16l3-5V37l-3-5H42ZM32 8l10 24m26-24L58 32M17 23l22 14m44-14L61 37M17 77l22-14m44 14L61 63M32 92l10-24m26 24L58 68"
                })
            ]
        })
    });
};
var DiamondProfileLink = function(param) {
    var profile = param.profile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: (0,_diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .diamondProfilePath */ .qZ)(profile.slug),
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "tw-block tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-5 tw-text-jr-green hover:tw-border-jr-green focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-jr-gold",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "tw-block tw-text-[15px] tw-font-medium",
                    children: profile.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "tw-mt-3 tw-block tw-text-[13px]",
                    children: [
                        "Xem cấu h\xecnh v\xe0 gi\xe1 tham khảo ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "aria-hidden": "true",
                            children: "→"
                        })
                    ]
                })
            ]
        })
    });
};
var ReferenceCard = function(param) {
    var entry = param.entry, usd = param.usd;
    var profile = entry.profile, estimate = entry.estimate;
    var shape = _diamond_config__WEBPACK_IMPORTED_MODULE_5__/* .SHAPES.find */ .HS.find(function(param) {
        var value = param.value;
        return value === profile.input.shape;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: (0,_diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .diamondProfilePath */ .qZ)(profile.slug),
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            "aria-label": "Xem chi tiết ".concat(profile.name),
            className: "tw-group tw-flex tw-h-full tw-min-w-0 tw-flex-col tw-rounded-xl tw-border tw-border-jr-line tw-bg-white tw-p-5 sm:tw-p-6 hover:tw-border-jr-green focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-jr-gold",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "tw-flex tw-h-20 tw-w-20 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#F0F5F0] tw-text-jr-green",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiamondIllustration, {
                                shape: profile.input.shape
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-min-w-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-m-0 tw-text-[12px] tw-uppercase tw-tracking-wider tw-text-jr-gold",
                                    children: shape.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                    className: "tw-mt-1 tw-mb-0 tw-font-jr tw-text-[25px] tw-font-normal tw-leading-tight tw-text-jr-ink",
                                    children: [
                                        diamondCarat(profile.input.carat),
                                        " carat"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "tw-mt-2 tw-mb-0 tw-text-[13px] tw-text-jr-mute",
                                    children: [
                                        "M\xe0u ",
                                        profile.input.color,
                                        " \xb7 ",
                                        profile.input.clarity
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-mt-5 tw-border-0 tw-border-t tw-border-solid tw-border-jr-line tw-pt-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "tw-m-0 tw-text-[12px] tw-text-jr-mute",
                            children: "Gi\xe1 ước t\xednh quốc tế"
                        }),
                        estimate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "tw-mt-1 tw-mb-0 tw-text-[25px] tw-font-medium tw-tabular-nums tw-text-jr-green",
                                    children: [
                                        diamondUsd(estimate.priceUsd),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "tw-text-[12px] tw-font-normal tw-text-jr-mute",
                                            children: "USD"
                                        })
                                    ]
                                }),
                                (usd === null || usd === void 0 ? void 0 : usd.sell) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "tw-mt-1 tw-mb-0 tw-text-[14px] tw-tabular-nums tw-text-jr-ink",
                                    children: [
                                        "≈ ",
                                        diamondVnd(estimate.priceUsd * usd.sell),
                                        " ₫"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "tw-mt-3 tw-mb-0 tw-text-[12px] tw-text-jr-mute",
                                    children: [
                                        "Nguồn: StoneAlgo \xb7 ",
                                        diamondDate(estimate.updatedAt)
                                    ]
                                }),
                                estimate.stale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "tw-mt-2 tw-mb-0 tw-text-[12px] tw-leading-relaxed tw-text-jr-mute",
                                    children: "Gi\xe1 gần nhất \xb7 đang kiểm tra lại nguồn"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "tw-mt-2 tw-mb-0 tw-text-[14px] tw-leading-relaxed tw-text-jr-mute",
                            children: "Gi\xe1 đang được bổ sung. Xem th\xf4ng số v\xe0 li\xean kết đối chiếu trong trang chi tiết."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "tw-mt-auto tw-flex tw-items-center tw-justify-between tw-gap-2 tw-pt-5 tw-text-[14px] tw-font-medium tw-text-jr-green",
                    children: [
                        "Xem chi tiết ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            "aria-hidden": "true",
                            className: "group-hover:tw-translate-x-1",
                            children: "→"
                        })
                    ]
                })
            ]
        })
    });
};
var pageHref = function(page) {
    return "".concat((0,_diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .diamondCataloguePath */ .pq)(page), "#danh-sach-gia");
};
var pageLinkClass = "tw-inline-flex tw-min-h-[44px] tw-items-center tw-justify-center tw-rounded tw-border tw-border-jr-line tw-bg-white tw-px-4 tw-text-[14px] tw-text-jr-green hover:tw-border-jr-green focus-visible:tw-outline-jr-gold";
var weightLinks = _diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .DIAMOND_PROFILES.flatMap */ .oO.flatMap(function(profile, index) {
    return index === 0 || profile.input.carat !== _diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .DIAMOND_PROFILES */ .oO[index - 1].input.carat ? [
        {
            carat: profile.input.carat,
            page: Math.floor(index / _diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .DIAMOND_PAGE_SIZE */ .jJ) + 1
        }
    ] : [];
});
var DiamondPagination = function(param) {
    var page = param.page, pageCount = param.pageCount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        "aria-label": "Ph\xe2n trang gi\xe1 kim cương",
        className: "tw-mt-8 tw-grid tw-grid-cols-2 sm:tw-grid-cols-[1fr_auto_1fr] tw-items-center tw-gap-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-col-start-1 tw-row-start-2 sm:tw-row-start-1 tw-justify-self-start",
                children: page > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: pageHref(page - 1),
                    prefetch: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        rel: "prev",
                        className: pageLinkClass,
                        children: "← Trước"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-disabled": "true",
                    className: "".concat(pageLinkClass, " tw-opacity-40"),
                    children: "← Trước"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-col-span-2 sm:tw-col-span-1 sm:tw-col-start-2 tw-row-start-1 tw-flex tw-min-w-0 tw-justify-center tw-gap-1",
                children: (0,_diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .diamondPaginationPages */ .FO)(page, pageCount).map(function(number, index) {
                    return number === "ellipsis" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": "true",
                        className: "tw-inline-flex tw-w-3 tw-shrink-0 tw-items-center tw-justify-center tw-text-jr-mute",
                        children: "…"
                    }, "gap-".concat(index)) : number === page ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-current": "page",
                        "aria-label": "Trang ".concat(number),
                        className: "tw-inline-flex tw-h-11 tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded tw-bg-jr-green tw-text-[14px] tw-font-medium tw-text-white",
                        children: number
                    }, number) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: pageHref(number),
                        prefetch: false,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            "aria-label": "Trang ".concat(number),
                            className: "".concat(pageLinkClass, " tw-w-11 tw-shrink-0 !tw-px-0"),
                            children: number
                        })
                    }, number);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-col-start-2 sm:tw-col-start-3 tw-row-start-2 sm:tw-row-start-1 tw-justify-self-end",
                children: page < pageCount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: pageHref(page + 1),
                    prefetch: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        rel: "next",
                        className: pageLinkClass,
                        children: "Sau →"
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    "aria-disabled": "true",
                    className: "".concat(pageLinkClass, " tw-opacity-40"),
                    children: "Sau →"
                })
            })
        ]
    });
};
var DiamondCatalogue = function(param) {
    var data = param.data, _usd = param.usd, usd = _usd === void 0 ? null : _usd, _standalone = param.standalone, standalone = _standalone === void 0 ? false : _standalone;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Section */ .$0, {
        id: "danh-sach-gia",
        className: "tw-scroll-mt-6 ".concat(standalone ? "!tw-pt-0" : "!tw-pt-8", " !tw-pb-8"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiamondNavigationStatus, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_JsonLd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                schema: {
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "@id": "".concat(_constants_business__WEBPACK_IMPORTED_MODULE_8__/* .BUSINESS.appUrl */ .aL.appUrl).concat((0,_diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .diamondCataloguePath */ .pq)(data.page), "#reference-list"),
                    name: "Gi\xe1 tham khảo kim cương – Trang ".concat(data.page),
                    numberOfItems: data.total,
                    itemListElement: data.entries.map(function(param, index) {
                        var profile = param.profile;
                        return {
                            "@type": "ListItem",
                            position: (data.page - 1) * _diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .DIAMOND_PAGE_SIZE */ .jJ + index + 1,
                            name: profile.name,
                            url: "".concat(_constants_business__WEBPACK_IMPORTED_MODULE_8__/* .BUSINESS.appUrl */ .aL.appUrl).concat((0,_diamond_catalogue__WEBPACK_IMPORTED_MODULE_4__/* .diamondProfilePath */ .qZ)(profile.slug))
                        };
                    })
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-mb-6 tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Eyebrow */ .j4, {
                                children: "SO S\xc1NH THEO CẤU H\xccNH"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "tw-mt-2 tw-mb-0 tw-font-jr tw-text-[28px] md:tw-text-[36px] tw-font-normal tw-leading-tight",
                                children: "Bảng gi\xe1 kim cương tham khảo"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "tw-mt-3 tw-mb-0 tw-max-w-[740px] tw-text-[14px] tw-leading-relaxed tw-text-jr-mute",
                                children: "Chọn một cấu h\xecnh để xem mức ước t\xednh, th\xf4ng số v\xe0 nguồn đối chiếu. C\xe1c mục dưới đ\xe2y l\xe0 cấu h\xecnh tham khảo, kh\xf4ng phải từng vi\xean đ\xe1 đang c\xf3 h\xe0ng."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "tw-m-0 tw-text-[13px] tw-text-jr-mute",
                        children: [
                            data.total,
                            " cấu h\xecnh \xb7 Trang ",
                            data.page,
                            "/",
                            data.pageCount
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-mb-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "tw-mt-0 tw-mb-3 tw-text-[13px] tw-font-medium tw-text-jr-mute",
                        children: "Xem theo trọng lượng"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                        "aria-label": "Trọng lượng kim cương",
                        className: "tw-flex tw-flex-wrap tw-gap-2",
                        children: weightLinks.map(function(param) {
                            var carat = param.carat, page = param.page;
                            var ref;
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: pageHref(page),
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "tw-inline-flex tw-min-h-[44px] tw-items-center tw-justify-center tw-rounded tw-border tw-px-3 tw-text-[13px] ".concat(carat === ((ref = data.entries[0]) === null || ref === void 0 ? void 0 : ref.profile.input.carat) ? "tw-border-jr-green tw-bg-jr-green tw-text-white" : "tw-border-jr-line tw-bg-white tw-text-jr-green hover:tw-border-jr-green"),
                                    children: [
                                        diamondCarat(carat),
                                        " ct"
                                    ]
                                })
                            }, carat);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-grid tw-gap-4 md:tw-grid-cols-2 lg:tw-grid-cols-3",
                children: data.entries.map(function(entry) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReferenceCard, {
                        entry: entry,
                        usd: usd
                    }, entry.profile.slug);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "tw-mt-5 tw-mb-0 tw-text-[12px] tw-leading-relaxed tw-text-jr-mute",
                children: [
                    "Gi\xe1 ước t\xednh từ StoneAlgo; gi\xe1 giao dịch tại An Thư được x\xe1c nhận theo từng vi\xean đ\xe1.",
                    (usd === null || usd === void 0 ? void 0 : usd.sell) ? " Quy đổi theo tỷ gi\xe1 b\xe1n Vietcombank ".concat(diamondVnd(usd.sell), " VND/USD, dữ liệu ng\xe0y ").concat(diamondDate(usd.updatedAt), ".") : ""
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiamondPagination, {
                page: data.page,
                pageCount: data.pageCount
            })
        ]
    });
};


/***/ }),

/***/ 29233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FO": function() { return /* binding */ diamondPaginationPages; },
/* harmony export */   "jJ": function() { return /* binding */ DIAMOND_PAGE_SIZE; },
/* harmony export */   "oO": function() { return /* binding */ DIAMOND_PROFILES; },
/* harmony export */   "pq": function() { return /* binding */ diamondCataloguePath; },
/* harmony export */   "qZ": function() { return /* binding */ diamondProfilePath; }
/* harmony export */ });
/* unused harmony exports DIAMOND_PAGE_COUNT, getDiamondProfile, getDiamondPage, parseDiamondPage */
var shapes = [
    {
        value: "round",
        name: "Round"
    },
    {
        value: "oval",
        name: "Oval"
    },
    {
        value: "emerald",
        name: "Emerald"
    }, 
];
var colors = [
    "D",
    "E",
    "F",
    "G",
    "H",
    "I"
];
var clarities = [
    "VVS1",
    "VVS2",
    "VS1",
    "VS2"
];
var qualities = colors.flatMap(function(color) {
    return clarities.map(function(clarity) {
        return {
            color: color,
            clarity: clarity
        };
    });
});
/** Bounded price configurations, ordered by carat, shape, color and clarity. */ var DIAMOND_PROFILES = [
    0.3,
    0.4,
    0.5,
    0.6,
    0.7,
    0.8,
    0.9,
    1,
    1.1,
    1.2,
    1.3,
    1.4,
    1.5,
    1.6,
    1.7,
    1.8,
    1.9,
    2,
    2.5,
    3
].flatMap(function(carat) {
    return shapes.flatMap(function(shape) {
        return qualities.map(function(param) {
            var color = param.color, clarity = param.clarity;
            return {
                slug: "".concat(shape.value, "-").concat(carat.toFixed(2).replace(".", "-"), "-carat-").concat(color.toLowerCase(), "-").concat(clarity.toLowerCase()),
                name: "Kim cương ".concat(shape.name, " ").concat(carat.toFixed(2).replace(".", ","), " carat ").concat(color, "/").concat(clarity),
                input: {
                    shape: shape.value,
                    carat: carat,
                    color: color,
                    clarity: clarity,
                    cut: "excellent",
                    symmetry: "excellent",
                    polish: "excellent",
                    fluorescence: "none"
                }
            };
        });
    });
});
var DIAMOND_PAGE_SIZE = 6;
var DIAMOND_PAGE_COUNT = Math.ceil(DIAMOND_PROFILES.length / DIAMOND_PAGE_SIZE);
var getDiamondProfile = function(slug) {
    return typeof slug === "string" ? DIAMOND_PROFILES.find(function(profile) {
        return profile.slug === slug;
    }) || null : null;
};
var getDiamondPage = function(page) {
    if (!Number.isInteger(page) || page < 1 || page > DIAMOND_PAGE_COUNT) return null;
    return DIAMOND_PROFILES.slice((page - 1) * DIAMOND_PAGE_SIZE, page * DIAMOND_PAGE_SIZE);
};
/** Route parameters must have a single canonical integer representation. */ var parseDiamondPage = function(value) {
    if (typeof value !== "string" || !/^[1-9]\d*$/.test(value)) return null;
    var page = Number(value);
    return getDiamondPage(page) ? page : null;
};
var diamondProfilePath = function(slug) {
    return "/bang-gia/kim-cuong/".concat(slug, "/");
};
var diamondCataloguePath = function(page) {
    return page === 1 ? "/bang-gia/kim-cuong/" : "/bang-gia/kim-cuong/trang/".concat(page, "/");
};
/** Keep long catalogues navigable without rendering every page number. */ var diamondPaginationPages = function(page, pageCount) {
    if (!Number.isSafeInteger(page) || !Number.isSafeInteger(pageCount) || pageCount < 1 || page < 1 || page > pageCount) return [];
    var candidates = [
        1,
        pageCount,
        page - 1,
        page,
        page + 1
    ];
    if (page === 1) candidates.push(3);
    if (page === pageCount) candidates.push(pageCount - 2);
    var pages = Array.from(new Set(candidates.filter(function(value) {
        return value >= 1 && value <= pageCount;
    }))).sort(function(a, b) {
        return a - b;
    });
    var result = [];
    pages.forEach(function(value, index) {
        if (index > 0 && value - pages[index - 1] > 1) result.push("ellipsis");
        result.push(value);
    });
    return result;
};


/***/ }),

/***/ 55187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ COLORS; },
/* harmony export */   "HS": function() { return /* binding */ SHAPES; },
/* harmony export */   "J6": function() { return /* binding */ CLARITIES; },
/* harmony export */   "NY": function() { return /* binding */ FLUORESCENCE; },
/* harmony export */   "Tw": function() { return /* binding */ GRADES; },
/* harmony export */   "Vr": function() { return /* binding */ DEFAULT_DIAMOND_INPUT; },
/* harmony export */   "WB": function() { return /* binding */ buildDiamondSourceUrl; }
/* harmony export */ });
var SHAPES = [
    {
        value: "round",
        label: "Tr\xf2n",
        name: "Round"
    },
    {
        value: "cushion",
        label: "Đệm",
        name: "Cushion"
    },
    {
        value: "emerald",
        label: "Chữ nhật",
        name: "Emerald"
    },
    {
        value: "oval",
        label: "Oval",
        name: "Oval"
    },
    {
        value: "princess",
        label: "Vu\xf4ng",
        name: "Princess"
    },
    {
        value: "pear",
        label: "Giọt lệ",
        name: "Pear"
    },
    {
        value: "radiant",
        label: "Radiant",
        name: "Radiant"
    },
    {
        value: "marquise",
        label: "Hạt th\xf3c",
        name: "Marquise"
    },
    {
        value: "asscher",
        label: "Asscher",
        name: "Asscher"
    },
    {
        value: "heart",
        label: "Tr\xe1i tim",
        name: "Heart"
    }, 
];
var COLORS = [
    "K",
    "J",
    "I",
    "H",
    "G",
    "F",
    "E",
    "D"
];
var CLARITIES = [
    "SI2",
    "SI1",
    "VS2",
    "VS1",
    "VVS2",
    "VVS1",
    "IF",
    "FL"
];
var GRADES = [
    {
        value: "fair",
        label: "Fair"
    },
    {
        value: "good",
        label: "Good"
    },
    {
        value: "very-good",
        label: "Very Good"
    },
    {
        value: "excellent",
        label: "Excellent"
    }, 
];
var FLUORESCENCE = [
    {
        value: "very-strong",
        label: "Rất mạnh"
    },
    {
        value: "strong",
        label: "Mạnh"
    },
    {
        value: "medium",
        label: "Trung b\xecnh"
    },
    {
        value: "faint",
        label: "Nhẹ"
    },
    {
        value: "none",
        label: "Kh\xf4ng"
    }, 
];
var DEFAULT_DIAMOND_INPUT = {
    shape: "round",
    carat: 1,
    color: "G",
    clarity: "VS2",
    cut: "excellent",
    symmetry: "excellent",
    polish: "excellent",
    fluorescence: "none"
};
/** Public calculator links emitted by StoneAlgo's own input controls. */ var buildDiamondSourceUrl = function(input) {
    var grades = GRADES.map(function(param) {
        var value = param.value;
        return value;
    });
    var params = new URLSearchParams({
        a: String(SHAPES.findIndex(function(param) {
            var value = param.value;
            return value === input.shape;
        }) + 1),
        b: String(input.carat),
        c: String(COLORS.indexOf(input.color) + 1),
        d: String(CLARITIES.indexOf(input.clarity) + 1),
        e: String(grades.indexOf(input.cut) + 1),
        f: String(grades.indexOf(input.symmetry) + 1),
        g: String(grades.indexOf(input.polish) + 1),
        h: String(FLUORESCENCE.findIndex(function(param) {
            var value = param.value;
            return value === input.fluorescence;
        }) + 1),
        i: "0"
    });
    return "https://www.stonealgo.com/diamond-price-calculator/calc?".concat(params);
};


/***/ }),

/***/ 16609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ PriceTabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _market_pages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71744);




var TABS = [
    {
        key: "diamond",
        label: "Kim cương",
        detail: "Gi\xe1 tham khảo quốc tế",
        icon: "diamond"
    },
    {
        key: "gold",
        label: "Gi\xe1 v\xe0ng",
        detail: "Thị trường trong nước",
        icon: "gold"
    },
    {
        key: "forex",
        label: "Ngoại tệ",
        detail: "Ngoại tệ / VND",
        icon: "usd"
    }, 
];
var TabIcon = function(param) {
    var type = param.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        className: "tw-h-7 tw-w-7 tw-shrink-0",
        "aria-hidden": "true",
        children: type === "gold" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M7 18h18l4 9H3l4-9ZM11 5h10l4 9H7l4-9Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m11 5 3 9m7-9-3 9M7 18l4 9m14-9-4 9"
                })
            ]
        }) : type === "usd" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "16",
                    cy: "16",
                    r: "12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M21 11c-2-4-11-3-10 2 1 4 10 2 10 7 0 5-9 5-11 1m6-15v20"
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "m3 12 7-8h12l7 8-13 16L3 12Z"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3 12h26M10 4l-1 8 7 16 7-16-1-8m-12 0 6 8 6-8"
                })
            ]
        })
    });
};
var PriceTabs = function(param) {
    var active = param.active;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-mb-5 md:tw-mb-7",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            "aria-label": "C\xe1c bảng gi\xe1",
            className: "tw-grid tw-grid-cols-3 tw-border tw-border-jr-line tw-rounded-lg tw-overflow-hidden tw-bg-white",
            children: TABS.map(function(tab) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: _market_pages__WEBPACK_IMPORTED_MODULE_3__/* .MARKET_PAGES */ .x_[tab.key].path,
                    scroll: false,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        "aria-current": active === tab.key ? "page" : undefined,
                        className: "tw-relative tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center sm:tw-justify-start tw-gap-2 sm:tw-gap-4 tw-px-2 sm:tw-px-6 tw-py-4 tw-transition-colors focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-[-4px] focus-visible:tw-outline-jr-gold ".concat(active === tab.key ? "tw-bg-jr-green tw-text-white" : "tw-bg-white tw-text-jr-green hover:tw-bg-[#F2F5F0]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "tw-hidden sm:tw-block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabIcon, {
                                    type: tab.icon
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "tw-min-w-0 tw-text-center sm:tw-text-left",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "tw-block tw-text-[13px] sm:tw-text-[16px] tw-font-medium",
                                        children: tab.label
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "tw-hidden md:tw-block tw-mt-1 tw-text-[12px] ".concat(active === tab.key ? "tw-text-white/75" : "tw-text-jr-mute"),
                                        children: tab.detail
                                    })
                                ]
                            }),
                            active === tab.key && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "tw-absolute tw-bottom-0 tw-inset-x-4 tw-h-[3px] tw-bg-[#D9BF7C]"
                            })
                        ]
                    })
                }, tab.key);
            })
        })
    });
};


/***/ })

}]);